// main.ts
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { vueKeycloak } from '@josempgon/vue-keycloak'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import './styles/tailwind.css'

function kcBaseUrl() {
    return (import.meta.env.VITE_KEYCLOAK_URL || 'https://auth.smsactivateonline.com:8443')
        .replace(/\/realms\/.*$/, '')
}

const app = createApp(App)

;(async () => {
    try {
        await vueKeycloak.install(app, {
            config: {
                url: kcBaseUrl(),
                realm: import.meta.env.VITE_KEYCLOAK_REALM || 'SAO',
                clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'webapi_client',
            },
            initOptions: {
                onLoad: 'check-sso',
                pkceMethod: 'S256',
                responseMode: 'query',
                redirectUri: location.origin + '/',         // этот URI должен быть в Valid Redirect URIs
                checkLoginIframe: false,
                silentCheckSsoRedirectUri: location.origin + '/silent-check-sso.html',
                silentCheckSsoFallback: true,
            },
            onInitError: (e) => console.warn('[vue-keycloak] init failed (non-fatal):', e),
        })
    } catch (e) {
        console.warn('[vue-keycloak] install error (non-fatal):', e)
    } finally {
        app.use(router)
        app.use(ElementPlus)
        
        const { setKeycloakGetter } = await import('./api/axios')
        setKeycloakGetter(() => app.config.globalProperties.$keycloak)
        
        app.mount('#app')
    }
})()
